import React, {useEffect} from 'react';
import ActionRequiredGrid from '../../../features/cfi/action-required-grid/components/ActionRequiredGrid';
import {useParams, useSearchParams} from "react-router-dom";
import {useTitle} from "../../../contexts/title";
import {useGetActionsRequired} from '../../../api/ar';
import {AR} from '../../../types/enums';

export default function ActionRequiredOrdersPage() {
	const pageTitle = useTitle();
	const params = useParams();
	const [searchParams] = useSearchParams();
	const actionRequiredID = parseInt(params.actionRequiredID!);
	const actionsRequired = useGetActionsRequired();
	const pendingOnly = searchParams.get("pending") === "true";
	const pastDueOnly = searchParams.get("pastDue") === "true"
	const activeOnly = searchParams.get("active") === "true"

	useEffect(() => {
		if (actionsRequired.data) {

			let title = actionsRequired.data.find(ar => ar.actionRequiredID === actionRequiredID)?.description ?? '';

			if (actionRequiredID === AR.CfiValidateChangeOrder)
				title = 'Validate Change Orders';

			if (actionRequiredID === AR.CfiUploadPostTemplateDrawing)
				title = 'Upload Post Template Drawing';

			if (pendingOnly)
				title += " (Pending Orders)";
			else if (pastDueOnly)
				title += " (Past Due Orders)";
			else if (activeOnly)
				title += " (Active Orders)";

			pageTitle.setTitle(title);
		}
	}, [actionsRequired.data, pageTitle, actionRequiredID, activeOnly, pastDueOnly, pendingOnly]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<ActionRequiredGrid
					actionRequiredID={actionRequiredID}
					pendingOnly={pendingOnly}
					pastDueOnly={pastDueOnly}
					activeOnly={activeOnly}
				/>
			</div>
		</React.Fragment>
	)
} 
